export default "__VITE_PUBLIC_ASSET__18c4751b__"